import { render, staticRenderFns } from "./SliderNavigation.vue?vue&type=template&id=1df20f6f&scoped=true"
import script from "./SliderNavigation.vue?vue&type=script&lang=js"
export * from "./SliderNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df20f6f",
  null
  
)

export default component.exports